import React, { PureComponent } from "react";

import RunnerNumber from "../../_atom/RunnerNumber";
import { RunnerContainer, RunnerNumberContainer } from "./styled-components";

export default class RunnerNumberWithName extends PureComponent {
  static defaultProps = {
    runnerId: "",
    raceTypeCode: "T",
    isFavorite: false,
    arrowDirection: "none",
    runnerName: ""
  };

  render() {
    return (
      <RunnerContainer>
        {this.props.runnerId && (
          <RunnerNumberContainer>
            <RunnerNumber {...this.props} />
          </RunnerNumberContainer>
        )}
        {this.props.runnerName}
      </RunnerContainer>
    );
  }
}
